import type { FC, ReactNode } from 'react';
import ActionButton from './action-button';
import Overlay from './overlay';
import styles from '../styles/action-dialog.module.scss';

export const ActionDialog: FC<{
    title: string;
    children: ReactNode;
    onClose: () => void;
    onOk: () => void;
    closeLabel?: string;
    okLabel?: string;
    loading?: boolean;
}> = ({
    title,
    children,
    onClose,
    onOk,
    closeLabel = '閉じる',
    okLabel = '実行',
    loading = false,
}) => {
    return (
        <Overlay>
            <div className={styles.dialog}>
                <div className={styles.title}>{title}</div>
                <div className={styles.infoBox}>{children}</div>
                <div className={styles.actions}>
                    <ActionButton
                        className={styles.actionButton}
                        onClick={onClose}
                        primary={false}
                        loading={loading}
                        title={closeLabel}
                        type="button"
                    />
                    <ActionButton
                        className={styles.actionButton}
                        onClick={onOk}
                        loading={loading}
                        title={okLabel}
                        type="button"
                    />
                </div>
            </div>
        </Overlay>
    );
};
